import React from 'react';
import {
  CalibrationCell_EmployeeTopicFragment,
  CalibrationSessionQuery,
} from '../../../../__generated__/graphql';
import { EmployeeWithAvatar } from '../../../../components/Employee/EmployeeWithAvatar';
import { CalibrationCell } from './CalibrationCell';

type Topic = CalibrationSessionQuery['calibrationSession']['topics'][number];

type Props = {
  employeeId: string;
  employeeName: string;
  employeePosition: string | null;
  employeeAvatarUrl: string | null;
  topics: ReadonlyArray<Topic>;
  employeeTopicsByTopic: Map<string, CalibrationCell_EmployeeTopicFragment>;
};

export const EmployeeRow: React.FC<Props> = ({
  employeeName,
  employeePosition,
  employeeAvatarUrl,
  topics,
  employeeTopicsByTopic,
}) => {
  return (
    <tr>
      <td className="align-middle">
        <EmployeeWithAvatar
          employee={{
            name: employeeName,
            avatarUrl: employeeAvatarUrl,
          }}
          additionalInfo={employeePosition}
          size="xs"
        />
      </td>
      {topics.map((topic) => {
        const et = employeeTopicsByTopic.get(topic.Id);
        return (
          <td key={topic.Id} className="align-middle">
            {et ? <CalibrationCell employeeTopic={et} /> : null}
          </td>
        );
      })}
    </tr>
  );
};
